export default "__VITE_ASSET__DOpKEosl__"